import { Button, Group } from '@mantine/core';
import { Dispatch, SetStateAction } from 'react';
import { MerchantOnboardingStatus } from '../../../enums/merchant-onboarding-status';
interface ApproveDeclineButtonProps {
  setDOpened: Dispatch<SetStateAction<boolean>>;
  setAOpened: Dispatch<SetStateAction<boolean>>;
  onboardingStatus: MerchantOnboardingStatus | undefined;
  isLoading: boolean;
}
function ApproveDeclineButton(props: ApproveDeclineButtonProps) {
  const { setDOpened, setAOpened, onboardingStatus, isLoading } = props;

  return (
    <Group>
      <Button
        color='green'
        onClick={() => setAOpened(true)}
        data-cy='approveButton'
        disabled={
          onboardingStatus === MerchantOnboardingStatus.APPROVED || isLoading
        }
      >
        APPROVE
      </Button>
      <Button
        color='red'
        onClick={() => setDOpened(true)}
        data-cy='declineButton'
        disabled={
          onboardingStatus === MerchantOnboardingStatus.DECLINED || isLoading
        }
      >
        DECLINE
      </Button>
    </Group>
  );
}

export default ApproveDeclineButton;
